import controller from './carousel-banner.controller';
import template from './carousel-banner.view.html';

let CarouselBannerComponent = {
  template,
  controller,
  bindings : {
    cbItems : '<',
    cbName : '<'
  }
};

export default CarouselBannerComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/components/banners/carousel-banner/carousel-banner.component.js
 **/